import { createAction } from "redux-actions";
import { createPromiseAction } from "../../utils/createPromiseAction";

export const ADD_TOUCHPOINT_REQUEST = "touchPoint/ADD_TOUCHPOINT_REQUEST";
export const ADD_TOUCHPOINT_SUCCESS = "touchPoint/ADD_TOUCHPOINT_SUCCESS";

export const UPDATE_TOUCHPOINT_REQUEST = "touchPoint/UPDATE_TOUCHPOINT_REQUEST";
export const UPDATE_TOUCHPOINT_SUCCESS = "touchPoint/UPDATE_TOUCHPOINT_SUCCESS";

export const GET_TOUCHPOINTS_REQUEST = "touchPoint/GET_TOUCHPOINTS_REQUEST";
export const GET_TOUCHPOINTS_SUCCESS = "touchPoint/GET_TOUCHPOINTS_SUCCESS";

export const GET_AUDIT_TOUCHPOINTS_REQUEST = "touchPoint/GET_AUDIT_TOUCHPOINTS_REQUEST";
export const GET_AUDIT_TOUCHPOINTS_SUCCESS = "touchPoint/GET_AUDIT_TOUCHPOINTS_SUCCESS";

export const GET_TOUCHPOINT_REQUEST = "touchPoint/GET_TOUCHPOINT_REQUEST";
export const GET_TOUCHPOINT_SUCCESS = "touchPoint/GET_TOUCHPOINT_SUCCESS";

export const LIKE_TOUCHPOINT_REQUEST = "touchPoint/LIKE_TOUCHPOINT_REQUEST";
export const LIKE_TOUCHPOINT_SUCCESS = "touchPoint/LIKE_TOUCHPOINT_SUCCESS";

export const FAVOR_TOUCHPOINT_REQUEST = "touchPoint/FAVOR_TOUCHPOINT_REQUEST";
export const FAVOR_TOUCHPOINT_SUCCESS = "touchPoint/FAVOR_TOUCHPOINT_SUCCESS";

export const DELETE_TOUCHPOINT_REQUEST = "touchPoint/DELETE_TOUCHPOINT_REQUEST";
export const DELETE_TOUCHPOINT_SUCCESS = "touchPoint/DELETE_TOUCHPOINT_SUCCESS";

export const ADD_TOUCHPOINT_COMMENT_REQUEST = "touchPoint/ADD_TOUCHPOINT_COMMENT_REQUEST";
export const ADD_TOUCHPOINT_COMMENT_SUCCESS = "touchPoint/ADD_TOUCHPOINT_COMMENT_SUCCESS";

export const DELETE_TOUCHPOINT_COMMENT_REQUEST = "touchPoint/DELETE_TOUCHPOINT_COMMENT_REQUEST";
export const DELETE_TOUCHPOINT_COMMENT_SUCCESS = "touchPoint/DELETE_TOUCHPOINT_COMMENT_SUCCESS";

export const LIKE_TOUCHPOINT_COMMENT_REQUEST = "touchPoint/LIKE_TOUCHPOINT_COMMENT_REQUEST";
export const LIKE_TOUCHPOINT_COMMENT_SUCCESS = "touchPoint/LIKE_TOUCHPOINT_COMMENT_SUCCESS";

export const EDIT_TOUCHPOINT_COMMENT_REQUEST = "touchPoint/EDIT_TOUCHPOINT_COMMENT_REQUEST";
export const EDIT_TOUCHPOINT_COMMENT_SUCCESS = "touchPoint/EDIT_TOUCHPOINT_COMMENT_SUCCESS";

export const touchPointActions = {
  addTouchPoint: createPromiseAction(ADD_TOUCHPOINT_REQUEST),
  addTouchPointSuccess: createAction(ADD_TOUCHPOINT_SUCCESS),
  updateTouchPoint: createPromiseAction(UPDATE_TOUCHPOINT_REQUEST),
  updateTouchPointSuccess: createAction(UPDATE_TOUCHPOINT_SUCCESS),
  getTouchPoints: createPromiseAction(GET_TOUCHPOINTS_REQUEST),
  getTouchPointsSuccess: createAction(GET_TOUCHPOINTS_SUCCESS),
  getAuditTouchPoints: createPromiseAction(GET_AUDIT_TOUCHPOINTS_REQUEST),
  getAuditTouchPointsSuccess: createAction(GET_AUDIT_TOUCHPOINTS_SUCCESS),
  getTouchPoint: createPromiseAction(GET_TOUCHPOINT_REQUEST),
  getTouchPointSuccess: createAction(GET_TOUCHPOINT_SUCCESS),
  likeTouchPoint: createPromiseAction(LIKE_TOUCHPOINT_REQUEST),
  likeTouchPointSuccess: createAction(LIKE_TOUCHPOINT_SUCCESS),
  favorTouchPoint: createPromiseAction(FAVOR_TOUCHPOINT_REQUEST),
  favorTouchPointSuccess: createAction(FAVOR_TOUCHPOINT_SUCCESS),
  deleteTouchPoint: createPromiseAction(DELETE_TOUCHPOINT_REQUEST),
  deleteTouchPointSuccess: createAction(DELETE_TOUCHPOINT_SUCCESS),
  addTouchPointComment: createPromiseAction(ADD_TOUCHPOINT_COMMENT_REQUEST),
  addTouchPointCommentSuccess: createAction(ADD_TOUCHPOINT_COMMENT_SUCCESS),
  deleteTouchPointComment: createPromiseAction(DELETE_TOUCHPOINT_COMMENT_REQUEST),
  deleteTouchPointCommentSuccess: createAction(DELETE_TOUCHPOINT_COMMENT_SUCCESS),
  likeTouchPointComment: createPromiseAction(LIKE_TOUCHPOINT_COMMENT_REQUEST),
  likeTouchPointCommentSuccess: createAction(LIKE_TOUCHPOINT_COMMENT_SUCCESS),
  editTouchPointComment: createPromiseAction(EDIT_TOUCHPOINT_COMMENT_REQUEST),
  editTouchPointCommentSuccess: createAction(EDIT_TOUCHPOINT_COMMENT_SUCCESS),
};
